<template lang="html">
  <section class="actionsheet-wrapper" v-show="isShow">
    <transition name="actionsheet-mask">
      <div
        class="mask mask-transparent"
        @click="hide"
        v-show="isShow"
        :style="{ 'margin-top': top }"
      ></div>
    </transition>
    <div
      class="actionsheet"
      :class="[heightClass, { 'actionsheet-toggle': isShow }]"
    >
      <actionTitle
        :title="actionHeader.title"
        :needArrow="actionHeader.needArrow"
      ></actionTitle>
      <div
        class="actionsheet-bd"
        :class="{
          hideTitle: actionHeader.title === '',
          'body-show': viewName === 'specification'
        }"
      >
        <component :is="viewName" :params="params"></component>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import starSheet from '@/components/common/sheet/star-sheet'
import dateSheet from '@/components/common/sheet/date-sheet'
import serviceSheet from '@/components/common/sheet/service-sheet'
import businessSheet from '@/components/common/sheet/business-sheet'
import calendar from './date-sheet'
import actionTitle from './actionTitle'
import enteringAreaSelect from '../entering/entering-area-sheet'
// import serviceCateSheet from '../product/service-sheet'

export default {
  props: {
    viewName: {
      type: String
    },
    callback: {
      // 点击浮层关闭回调
      type: Function
    },
    params: {
      type: Object,
      default: () => {}
    },
    top: {
      type: String,
      default: '45px'
    },
    heightClass: {
      type: String,
      defaut: ''
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.scrollTop = document.body.scrollTop
        // setTimeout(() => {
        // document.body.scrollTop = 0
        document.body.classList.add('of-hide')
        if (this.$route.name !== 'activity-share') {
          document.documentElement.classList.add('of-hide')
        }
        // }, 600)
      } else {
        document.body.className = ''
        document.documentElement.className = ''
        // document.body.scrollTop = this.scrollTop
      }
    }
  },
  mounted() {
    const actionsheet = document.querySelector('.actionsheet')
    if (actionsheet) {
      actionsheet.addEventListener('transitionend', () => {
        if (!this.isShow) {
          this.changeView('')
        }
      })
    }
    this.scrollTop = document.body.scrollTop
  },
  computed: {
    ...mapState({
      isShow: 'isActionSheetShow',
      actionHeader: 'actionHeader'
    })
  },
  methods: {
    ...mapMutations(['hideActionSheet', 'changeView']),
    hide() {
      this.hideActionSheet()
      if (this.callback) {
        this.callback()
      }
    }
  },
  components: {
    actionTitle,
    calendar,
    enteringAreaSelect,
    starSheet,
    dateSheet,
    serviceSheet,
    businessSheet
    // serviceCateSheet
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.mask,
.mask-transparent {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  // height:rem(1300px);
  margin-top: rem(90px);
}
.mask {
  background: rgba(0, 0, 0, 0.6);
}
.actionsheet {
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(0, -100%);
  backface-visibility: hidden;
  z-index: 50;
  width: 100%;
  height: rem(400px);
  margin-top: rem(90px);
  // max-height:rem(480px);
  background-color: #fff;
  transition: transform 0.3s;

  &.h800 {
    height: rem(800px);
  }
  .actionsheet-bd {
    position: absolute;
    top: 0;
    left: 0;
    bottom: -0.5px;
    right: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .body-show {
    overflow: visible;
  }
  .hideTitle {
    top: 0;
  }
}
.actionsheet-toggle {
  transform: translate(0, 0);
}
.actionsheet-mask-enter,
.actionsheet-mask-leave-active {
  opacity: 0;
}
.actionsheet-mask-leave-active,
.actionsheet-mask-enter-active {
  transition: opacity 300ms;
}
</style>
